export default {
    name: 'table-hint-info',
    data: function () {
        return {
            show: true
        };
    },
    props: {
        notice: {
            type: String,
            default: ''
        }
    }
};
